// extracted by mini-css-extract-plugin
module.exports = {"containerStats":"SectionStats_containerStats__O7qhl","statsNumber":"SectionStats_statsNumber____jMN","statsLabel":"SectionStats_statsLabel__cYhxP"};